const firebaseConfig = {
    apiKey: "AIzaSyBJAaWIIQ6-1BqeTnUhQF-xkHp7mGgosNo",
    authDomain: "auth-test-32c11.firebaseapp.com",
    databaseURL: "https://auth-test-32c11.firebaseio.com",
    projectId: "auth-test-32c11",
    storageBucket: "auth-test-32c11.appspot.com",
    messagingSenderId: "927131595266",
    appId: "1:927131595266:web:869f5daaaf24f5b229ad1b"
};

export default firebaseConfig;